import router from "@/modules/router";

export default {
	namespaced: true,

	state: {
		width: null
	},

	mutations: {
		width(state, width) {
			state.width = width;
		}
	},

	actions: {
		meta({getters}, {title}) {
			document.title = title ? `${title} - ${getters.title}` : getters.title;
		},
		error() {
			router.replace({name: "error", params: {title: "Error", text: "Server error"}});
		}
	},

	getters: {
		title(state, getters, rootState, rootGetters) {
			return rootGetters["config/title"];
		},
		width(state) {
			return state.width;
		},
		res(state, getters) {
			return {
				small: getters.width <= 1280,
				xsmall: getters.width <= 950
			}
		}
	}
};
